import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';

export interface MessageCSSStyle extends UIComponentCSSStyle
{
    getCloseButtonDivCSSStyle():object;
}

export class MessageCSSStyleImpl extends UIComponentCSSStyleImpl implements MessageCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:'100%',
            backgroundColor:"#F4F4F4",
            flex:'1',
            paddingleft:'5px'
        };
    }

    getInnerWrapperCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_5),
            marginLeft: "170px",
            marginRight: "170px",
            marginTop: "72px",
            marginBottom: "72px",
        };
    }

    getCloseButtonDivCSSStyle():object
    {
        return{
            float:"right", marginTop:'5px', marginRight:"5px",backgroundColor:'#F4F4F4',display:'flex'
        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/messagecomponent/messagecss.tsx